(function () {
  const Core = window.RB.Core;
  const { empower, buff } = window.RB.CardLib;
  const { relicBurn, tentacle } = window.RB.CardLib.ven;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Kinkou Lifeblade": {
      abilities: [
        empower({ energy: 2, pips: 0, anyPower: 0, domains: null }),
      ],
      selfMightSpecs: [{ n: 1, cond: { k: "selfEmpowered" } }],
      selfKwSpecs: [{ name: "ganking", value: null, cond: { k: "selfEmpowered" } }],
    },

    "Mel, Defiant Soul": {
      triggers: [
        {
          on: "empowered",
          optional: false,
          label: "When I become [Empowered], banish an enemy unit at a battlefield with 3 :rb_might: or less",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", maxMight: 3, enemy: true, atBf: true },
              prompt: "Banish...",
            },
          ],
          program: [{ op: "banish", to: "$t1" }],
          self: true,
        },
      ],
      abilities: [
        empower({ energy: 0, pips: 0, anyPower: 0, domains: null }, { costDiscard: 1, costDiscardType: "spell" }),
      ],
    },

    "Twilight Step": {
      play: [{ op: "move", to: "$t1", dest: "choose" }],
      targets: [{ bind: "t1", spec: { type: "unit", maxMight: 3 }, prompt: "Move..." }],
      flowCost: { energy: 4, pips: 1, anyPower: 0, domains: ["chaos"] },
    },

    "Up from the Deep": {
      play: [{ op: "token", name: "Tentacle", n: 2, loc: "base", exhausted: false }],
      flowCost: { energy: 3, pips: 0, anyPower: 0, domains: null },
    },

    "Mask Mother": {
      trashTriggers: [{
        on: "discarded", optional: true,
        label: "discarded: pay 1 Energy for +2 Might",
        condSpec: { k: "evSelfOrTrashed" },
        program: [
          {
            op: "payCost", varKey: "_mm", skipOnFail: 2,
            cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
          },
          {
            op: "choose", bind: "_mmu", spec: { type: "unit", friendly: true },
            prompt: "Give which friendly unit +2 Might this turn?",
          },
          buff("$_mmu", 2),
        ],
      }],
    },

    "Shadow Order Disciple": {
      triggers: [{
        on: "move", self: true, optional: true,
        label: "moved: Burn 1 for +1 Might",
        program: [
          { op: "burn", n: 1 },
          buff("source", 1),
        ],
      }],
    },

    "Shadowblade Lurker": {
      costMods: [{ energyLess: { trashName: true, times: 2 } }],
    },

    Spiderling: {
      selfMight: function (state, iid) {
        const o = state.objs[iid];
        if (!o || o.zone !== "board" || !o.loc) return 0;
        const myName = Core.name(state, iid);
        let n = 0;
        for (const other of Core.boardObjs(state)) {
          if (other === iid) continue;
          const oo = state.objs[other];
          if (!oo || oo.attachedTo || oo.controller !== o.controller) continue;
          if (!Core.isType(state, other, "unit")) continue;
          if (!Core.sameLoc(oo.loc, o.loc)) continue;
          if (Core.name(state, other) !== myName) continue;
          n++;
        }
        return n;
      },
    },

    "Tornado Warrior": {
      play: [{
        op: "if", cond: { k: "fromFacedown" },
        then: [{
          op: "may", prompt: "Empower something here until end of turn?",
          then: [
            {
              op: "choose", bind: "tw", spec: { here: true },
              prompt: "Empower which card here?",
            },
            { op: "empower", to: "$tw" },
            {
              op: "delayed", on: "endOfTurn", carry: ["tw"],
              label: "Tornado Warrior: disempower at end of turn",
              program: [{ op: "disempower", to: "$tw" }],
            },
          ],
        }],
      }],
    },

    "Gust Monk": {
      addCosts: [{
        optional: true, cond: null, label: "Gust Monk",
        cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
        thenTargets: [],
        then: [
          {
            op: "choose", bind: "_gb", spec: { zone: "trash", anyPlayer: true },
            prompt: "Banish which card from a trash?",
          },
          {
            op: "if", cond: { k: "targetsChosen", bind: "_gb" },
            then: [
              { op: "banish", to: "$_gb" },
              {
                op: "choose", bind: "_gu", spec: { type: "unit" },
                prompt: "Give which unit [Assault 2] this turn?",
              },
              { op: "grant", to: "$_gu", keyword: "assault", kwValue: 2, dur: "turn" },
            ],
          },
        ],
      }],
    },

    "Ravenbloom Prefect": {
      triggers: [{
        on: "played", optional: true,
        label: "opponent played a gear: banish me to banish it",
        condSpec: {
          k: "and",
          conds: [{ k: "not", cond: { k: "evYou" } }, { k: "evType", type: "gear" }],
        },
        program: [
          { op: "banish", to: "source" },
          { op: "banish", to: "$ev" },
        ],
      }],
    },

    "Shadows of the Past": {
      targets: [{
        bind: "t", spec: { zone: "trash", type: "unit", anyPlayer: true },
        min: 0, max: 2,
        prompt: "Return up to 2 units from trashes to their owners' hands",
      }],
      play: [{ op: "toHand", to: "$t" }],
    },

    "Tail-Cloaked Matriarch": {
      abilities: [empower({ energy: 2, pips: 1, anyPower: 0, domains: ["chaos"] }, { targets: [] })],
      triggers: [{
        on: "empowered", self: true, optional: true,
        label: "Empowered: play a cheap unit from your trash",
        program: [
          {
            op: "choose", bind: "_tm",
            spec: { zone: "trash", type: "unit", maxEnergy: 3, maxPips: 1 },
            prompt: "Play which unit from your trash to your base, ignoring its cost?",
          },
          { op: "playFrom", to: "$_tm", waive: "all", dest: "base" },
        ],
      }],
    },

    "Wind and Ghosts": {
      targets: [{
        bind: "t", spec: { type: "unit", atBf: true },
        prompt: "Choose a unit at a battlefield",
      }],
      play: [{
        op: "if", cond: { k: "targetMightAtMost", bind: "t", n: 3 },
        then: [{ op: "banish", to: "$t" }],
        else: [{ op: "toHand", to: "$t" }],
      }],
    },

    "Forgotten Relic": {
      play: relicBurn(),
      triggers: [{
        on: "beginningPhase", you: true,
        label: "start of your Beginning Phase: Burn 1",
        program: relicBurn(),
      }],
    },

    "Illaoi, Prophet of the Great Kraken": {
      play: tentacle(),
      triggers: [
        { on: "unitConquer", self: true, label: "conquered: Tentacle token", program: tentacle() },
        { on: "unitHold", self: true, label: "held: Tentacle token", program: tentacle() },
      ],
      selfMight: function (state, iid) {
        const o = state.objs[iid];
        if (!o || o.zone !== "board") return 0;
        let n = 0;
        for (const other of Core.boardObjs(state)) {
          const oo = state.objs[other];
          if (!oo || !oo.token || oo.attachedTo) continue;
          if (oo.controller !== o.controller) continue;
          if (!Core.isType(state, other, "unit")) continue;
          n++;
        }
        return n;
      },
    },

    "Minah Swiftfoot": {
      triggers: [{
        on: "move", self: true,
        label: "moved to a battlefield: choose one",
        condSpec: { k: "evToBf" },
        program: [
          {
            op: "option", varKey: "_mn", prompt: "Choose one",
            options: ["Each player discards 1", "Each player draws 1"],
          },
          {
            op: "if", cond: { k: "varEq", key: "_mn", value: 0 },
            then: [
              { op: "discard", n: 1 },
              { op: "discard", n: 1, who: "opponent" },
            ],
            else: [{ op: "draw", n: 1, who: "each" }],
          },
        ],
      }],
    },

    "Zed, Without a Sound": {
      triggers: [{
        on: "unitConquer", self: true,
        label: "conquered: Shadow Clone token",
        program: [{ op: "token", name: "Shadow Clone" }],
      }],
      abilities: [{
        cost: { energy: 1, pips: 1, anyPower: 0, domains: ["chaos"] },
        label: "Swap locations with a Shadow Clone",
        action: true,
        targets: [{
          bind: "sc", spec: { type: "unit", friendly: true, tag: "Shadow" },
          prompt: "Swap locations with which Shadow Clone?",
        }],
        program: [{ op: "swapLoc", a: "source", b: "$sc" }],
      }],
    },

    "Kennen, Storm of Shuriken": {
      play: [{ op: "burn", n: 2 }],
      triggers: [{
        on: "unitConquer", self: true,
        label: "conquered: give a spell in your trash [Flow] equal to its cost",
        targets: [{
          bind: "kn", spec: { type: "spell", zone: "trash" }, min: 0,
          prompt: "Give which spell in your trash [Flow] this turn?",
        }],
        program: [{ op: "grantFlow", to: "$kn", dur: "turn" }],
      }],
    },

    Kharox: {
      abilities: [empower({ energy: 6, pips: 2, anyPower: 0, domains: ["chaos"] }, { targets: [] })],
      triggers: [{
        on: "empowered", self: true,
        label: "Empowered: an opponent burns 3, then play a unit from their trash",
        program: [
          { op: "burn", who: "opponent", n: 3 },
          {
            op: "may", prompt: "Play a unit from their trash, ignoring its cost?",
            then: [
              {
                op: "choose", bind: "_kx", spec: { zone: "trash", type: "unit", enemy: true },
                prompt: "Play which unit from their trash, ignoring its cost?",
              },
              { op: "playFrom", to: "$_kx", waive: "all" },
            ],
          },
        ],
      }],
    },

    "Ocean Drake": {
      playToOpenBf: true,
      play: [{
        op: "may", prompt: "Return a non-Dragon unit to its owner's hand?",
        then: [
          {
            op: "choose", bind: "_od", spec: { type: "unit", notTag: "Dragon" },
            prompt: "Return which non-Dragon unit to its owner's hand?",
          },
          { op: "toHand", to: "$_od" },
        ],
      }],
    },

    "Decree of Discord": {
      play: [
        {
          op: "chooseBudget", bind: "d", n: 5, sameController: true,
          spec: { type: "unit", enemy: true, domain: "order" },
          prompt: "Return which enemy Order units to hand?",
        },
        { op: "toHand", to: "$d" },
      ],
    },

    "Stargazer": {
      auraCostMod: [{
        what: { type: "spell", hasKw: "flow" },
        fromZone: "trash",
        energyLess: 2,
        min: 1,
      }],
    },
  });
})();
